import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class ScheduleRegimeEdit extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      title: '',
      regimes_list: [
        {value: 'escala', label: this.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesRegimes.Escala},
        {value: 'administrativo', label: this.locale.RegimesDeEscala.RegimesDeTrabalho.opcoesRegimes.Administrativo},
      ],
      schedule_regimes: '',
      working_days: 0,
      days_off: 0,
      name: null,
      regime: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }


  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      type: newProps.schedule_regime.type,
      team_rubi: newProps.schedule_regime.team_rubi,
      schedule_rubi: newProps.schedule_regime.schedule_rubi,
      regime: newProps.schedule_regime.regime,
      working_days: newProps.schedule_regime.working_days,
      days_off: newProps.schedule_regime.days_off,
      name: newProps.schedule_regime.name,
    });
  }

  edit() {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.props.id,
      type: this.state.type,
      regime: this.state.regime,
      team_rubi: this.state.team_rubi,
      schedule_rubi: this.state.schedule_rubi,
      working_days: this.state.working_days,
      days_off: this.state.days_off,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/regime', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <tr>
        <td>
          <RequestApi ref={'request_api'} />
          <div className="form-group">
            <input type="text" name="name" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.Nome} value={self.state.name} onChange={self.handleChange.bind(self, 'name')} />
          </div>
        </td>
        {(this.state.type !== 'escala') ?
          <td>
            <RequestApi ref={'request_api'} />
            <div className="form-group">
              <input type="text" name="schedule_rubi" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.IdEscalaRubi} value={self.state.schedule_rubi} onChange={this.handleChange.bind(this, 'schedule_rubi')} />
            </div>
          </td>
          : ''
        }
        {(this.state.type !== 'escala') ?
          <td>
            <RequestApi ref={'request_api'} />
            <div className="form-group">
              <input type="text" name="team_rubi" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.IdTurmaRubi} value={self.state.team_rubi} onChange={this.handleChange.bind(this, 'team_rubi')} />
            </div>
          </td>
          : ''
        }

        <td>
          <div className="form-group">
            <Select
              className="form-field-name"
              name="regime"
              value={self.state.regime}
              searchable={true}
              placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.SelecionarRegime}
              onChange={self.handleSelectChange.bind(self, 'regime')}
              options={self.state.regimes_list}
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="number" name="working_days" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.Nome} value={self.state.working_days} onChange={self.handleChange.bind(self, 'working_days')} />
          </div>
        </td>
        <td>
          <div className="form-group">
            <input type="number" name="days_off" className="form-control" placeholder={this.locale.RegimesDeEscala.RegimesDeTrabalho.tabela.placeholder.Nome} value={self.state.days_off} onChange={self.handleChange.bind(self, 'days_off')} />
          </div>
        </td>
        <td>
          <div className="btn-group">
            <button type="submit" className="btn btn-primary" onClick={() => self.edit()}><i className="fa fa-fw fa-save"></i> {this.locale.general.editar}</button>
          </div>
        </td>
      </tr>
    );
  }
}

export default ScheduleRegimeEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleRegime/Elements/ScheduleRegimeEdit.js